<div class="park-flow" [ngSwitch]="stepKey">

  <!-- 1. Hotel: tipo de habitación + proveedor, y abajo la accesibilidad -->
  <ng-container *ngSwitchCase="'hotel'">
    <usb-park-rooms [roomTypes]="roomTypes"
                    [index]="index"
                    [nights]="nights"
                    [fallbackImage]="fallbackImage"
                    [selectedTypeKey]="choice?.roomType?.typeKey"
                    [selectedProviderId]="choice?.providerId"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [buttonColorActive]="buttonColorActive"
                    [buttonColorActiveDark]="buttonColorActiveDark"
                    [clientSetting]="clientSetting"
                    (choose)="onRoomChoose($event)">
    </usb-park-rooms>

    <usb-park-access *ngIf="choice && accessVariants.length"
                     [roomType]="roomType"
                     [rooms]="hotel?.additionalInfo?.rooms"
                     [hotelType]="hotelType"
                     [providerId]="providerId"
                     [index]="index"
                     [standardOffer]="standardOffer"
                     [selectedKey]="accessKey"
                     [currencies]="currencies"
                     [currencyAgency]="currencyAgency"
                     [buttonColorActive]="buttonColorActive"
                     [clientSetting]="clientSetting"
                     (choose)="onAccessChoose($event)">
    </usb-park-access>

    <!-- checkAvail de Full of Dreams al salir del hotel: trae los planes de comidas y los tickets -->
    <div *ngIf="loading" class="park-flow-loading" role="status" aria-live="polite">
      <div class="park-flow-loading-box">
        <i class="fas fa-spinner fa-spin fa-2x" aria-hidden="true"></i>
        <span>Consultando planes de comidas...</span>
      </div>
    </div>
  </ng-container>

  <!-- 2. Plan de comidas -->
  <ng-container *ngSwitchCase="'meals'">
    <usb-park-meals [roomType]="mealsRoomType"
                    [providerId]="providerId"
                    [index]="index"
                    [withTickets]="withTickets && !addonTickets && !usesCheckAvail"
                    [selectedPlan]="plan"
                    [currencies]="currencies"
                    [currencyAgency]="currencyAgency"
                    [buttonColorActive]="buttonColorActive"
                    (choose)="onMealChoose($event)">
    </usb-park-meals>
  </ng-container>

  <!-- 3. Tickets: se cargan al entrar (checkAvail con withTickets) -->
  <ng-container *ngSwitchCase="'tickets'">
    <usb-park-info [hotelType]="hotelType"></usb-park-info>

    <p *ngIf="loading" class="park-flow-msg">Buscando tickets disponibles...</p>
    <div *ngIf="!loading && error && !tickets" class="park-flow-msg">
      <p>{{ error }}</p>
      <button type="button" class="park-flow-retry" (click)="retryTickets()">Reintentar</button>
      <button *ngIf="allowNone" type="button" class="park-flow-retry" (click)="skipTickets()">Continuar solo con el hotel</button>
    </div>
    <ng-container *ngIf="!loading && tickets">
      <usb-park-tickets [options]="tickets?.options"
                        [hotelType]="hotelType"
                        [selectedType]="ticketMode"
                        [allowNone]="allowNone"
                        [adults]="adults"
                        [children]="childAges?.length || 0"
                        [sourceCurrency]="tickets?.currency || 'USD'"
                        [currencies]="currencies"
                        [currencyAgency]="currencyAgency"
                        [buttonColorActive]="buttonColorActive"
                        [buttonColorActiveDark]="buttonColorActiveDark"
                        (choose)="onTicketChoose($event)">
      </usb-park-tickets>

    </ng-container>
  </ng-container>

  <!-- 4. Días y fecha (calendario), con la galería y la información general del ticket -->
  <ng-container *ngSwitchCase="'days'">
    <div class="park-gallery" *ngIf="gallery.length">
      <img class="park-gallery-main" [src]="gallery[0]" alt="">
      <div class="park-gallery-side" *ngIf="gallery.length > 1">
        <img *ngFor="let img of gallery.slice(1, 3)" [src]="img" alt="">
      </div>
      <button *ngIf="images.length" type="button" class="park-gallery-more" (click)="photos.emit()">+ de {{ images.length }} fotos</button>
    </div>

    <div class="park-gallery-copy">
      <p class="park-gallery-text" [class.expanded]="textExpanded">{{ ticketsText }}</p>
      <button type="button" class="park-gallery-toggle" [style.color]="buttonColorActiveDark" (click)="textExpanded = !textExpanded">{{ textExpanded ? 'menos' : '... más.' }}</button>
    </div>

    <div class="park-general">
      <h4 class="park-general-title">Información General</h4>
      <div class="park-general-row">
        <img src="/assets/img/parks/disney/icons/calendar.png" alt="" aria-hidden="true">
        <div>
          <p class="park-general-name">{{ refundable ? 'Cancelación gratuita' : 'No reembolsable' }}</p>
          <p class="park-general-text">{{ cancellationText }}</p>
        </div>
      </div>
      <div class="park-general-row">
        <img src="/assets/img/parks/disney/icons/clock.png" alt="" aria-hidden="true">
        <div>
          <p class="park-general-name">Duración</p>
          <p class="park-general-text">{{ durationText }}</p>
        </div>
      </div>
      <div class="park-general-row" *ngIf="address">
        <img src="/assets/img/parks/disney/icons/pin.png" alt="" aria-hidden="true">
        <div>
          <p class="park-general-name">Ubicación</p>
          <p class="park-general-text">{{ address }}</p>
        </div>
      </div>
    </div>

    <usb-park-days [options]="tickets?.options"
                   [type]="ticketMode"
                   [addon]="addonTickets"
                   [adults]="adults"
                   [children]="childAges?.length || 0"
                   [arrivalDate]="arrivalDate"
                   [departureDate]="departureDate"
                   [selectedDays]="days"
                   [selectedKey]="ticketKey"
                   [selectedDate]="ticketDate"
                   [sourceCurrency]="tickets?.currency || 'USD'"
                   [currencies]="currencies"
                   [currencyAgency]="currencyAgency"
                   [buttonColorActive]="buttonColorActive"
                   (daysChange)="onDaysChoose($event)"
                   (dateChange)="onDateChoose($event)">
    </usb-park-days>
  </ng-container>

  <!-- 5. Resumen -->
  <div *ngSwitchCase="'summary'" class="park-summary">
    <h4 class="park-summary-title">Resumen de Tu Selección</h4>
    <div *ngIf="loading" class="park-flow-loading" role="status" aria-live="polite">
      <div class="park-flow-loading-box">
        <i class="fas fa-spinner fa-spin fa-2x" aria-hidden="true"></i>
        <span>Confirmando disponibilidad y precio...</span>
      </div>
    </div>
    <div *ngIf="!loading && error" class="park-flow-msg">
      <p>{{ error }}</p>
      <button type="button" class="park-flow-retry" (click)="retryConfirm()">Reintentar</button>
    </div>

    <div class="park-summary-card">
      <div class="park-summary-head">
        <p class="park-summary-heading">Detalle de Tarifas</p>
        <img *ngIf="provider.logo" class="park-summary-logo" [src]="provider.logo" alt="{{ provider.name }}">
        <span *ngIf="!provider.logo" class="park-summary-sub">{{ provider.name }}</span>
      </div>

      <div class="park-summary-row">
        <div>
          <p class="park-summary-name">Fechas</p>
          <p class="park-summary-sub">{{ stayDays }} {{ stayDays === 1 ? 'día' : 'días' }}</p>
        </div>
        <span class="park-summary-value">{{ arrivalDate | date:'dd/MM/yyyy' }} al {{ departureDate | date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="park-summary-row">
        <p class="park-summary-name">Ocupación</p>
        <span class="park-summary-value">{{ paxText }}</span>
      </div>

      <div class="park-summary-row" *ngIf="accessLabel">
        <p class="park-summary-name">Accesibilidad</p>
        <span class="park-summary-value">{{ accessLabel }}</span>
      </div>

      <div class="park-summary-row">
        <div>
          <p class="park-summary-name">Tarifa de Alojamiento</p>
          <p class="park-summary-sub">{{ hotel?.title }}</p>
          <p class="park-summary-sub">1X {{ roomType?.name }}</p>
        </div>
        <ng-container *ngTemplateOutlet="amount; context: { $implicit: breakdown.lodging }"></ng-container>
      </div>

      <ng-container *ngIf="withTickets && ticket">
        <div class="park-summary-row">
          <div>
            <p class="park-summary-name">Tarifa de Ticket</p>
            <p class="park-summary-sub">{{ ticketTitle }} ({{ ticketPaxText }})</p>
          </div>
          <ng-container *ngTemplateOutlet="amount; context: { $implicit: breakdown.ticket }"></ng-container>
        </div>
        <div class="park-summary-row" *ngIf="ticketDate">
          <p class="park-summary-name">Fechas del Ticket</p>
          <span class="park-summary-value">{{ ticketDate | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="park-summary-row">
          <p class="park-summary-name">Días de Parque</p>
          <span class="park-summary-value">{{ ticket.days }}</span>
        </div>
      </ng-container>
      <div class="park-summary-row" *ngIf="hasVariantPackages && ticketMode === 'none'">
        <p class="park-summary-name">Tickets</p>
        <span class="park-summary-value">Solo hotel</span>
      </div>

      <div class="park-summary-row" *ngIf="hasVariantPackages">
        <div>
          <p class="park-summary-name">Tarifa Plan de Comidas</p>
          <p class="park-summary-sub">{{ planName }}</p>
        </div>
        <ng-container *ngTemplateOutlet="amount; context: { $implicit: breakdown.meals }"></ng-container>
      </div>

      <div class="park-summary-policies" *ngIf="finalOffer && hasPolicies">
        <usb-accordion-info-product [items]="policyItems" [config]="policyConfig" [categoryId]="4" [infoRoom]="true">
          <ng-template #accordionContent let-item>
            <usb-cancellation-policies class="accordion-item-policies"
                                       [cancellationPolicies]="cancellationData"
                                       [currencies]="currencies"
                                       [currencyAgency]="currencyAgency"
                                       [categoryId]="1">
            </usb-cancellation-policies>
            <p class="park-summary-sub" *ngFor="let line of policyLines">{{ line }}</p>
          </ng-template>
        </usb-accordion-info-product>
      </div>

      <div class="park-summary-row park-summary-total">
        <p class="park-summary-name">Total Tarifa Neta</p>
        <ng-container *ngTemplateOutlet="amount; context: { $implicit: netTotal }"></ng-container>
      </div>
    </div>

    <div class="park-summary-actions">
      <button type="button" class="park-summary-back" (click)="back()">Atrás</button>
      <button type="button" class="park-summary-next" [style.background-color]="buttonColorActive"
              [disabled]="!canNext" (click)="next()">Continuar</button>
    </div>
  </div>

  <ng-template #amount let-value>
    <span class="park-summary-amount">
      {{ currencyAgency?.code }} {{ value | currencyConverterPure: currency: currencyAgency?.code: currencies | number: '1.2-2' }}
      <usb-tooltip-convert-amount *ngIf="clientSetting"
                                  [clientsSettingAppBooking]="clientSetting"
                                  [currencyProduct]="currency"
                                  [valueProduct]="value">
      </usb-tooltip-convert-amount>
    </span>
  </ng-template>
</div>
